import { render, staticRenderFns } from "./main-factors.vue?vue&type=template&id=73a43730&scoped=true&"
import script from "./main-factors.vue?vue&type=script&lang=js&"
export * from "./main-factors.vue?vue&type=script&lang=js&"
import style0 from "./main-factors.vue?vue&type=style&index=0&id=73a43730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a43730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a43730')) {
      api.createRecord('73a43730', component.options)
    } else {
      api.reload('73a43730', component.options)
    }
    module.hot.accept("./main-factors.vue?vue&type=template&id=73a43730&scoped=true&", function () {
      api.rerender('73a43730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/main-factors.vue"
export default component.exports